enum Product {
  LiveJasmin = 'livejasmin',
  Oranum = 'oranum',
}

export { Product };
